<template>
  <page-edicion>
    <page-header title="Estadísticas de ofertas" />
    <pivot
      :data="data"
      class="pivot"
      :fields="fields"
      :available-field-keys="availableFieldKeys"
      :row-field-keys="rowFieldKeys"
      :col-field-keys="colFieldKeys"
      :reducer="reducer"
      :default-show-settings="defaultShowSettings"
      available-fields-label-text="Campos disponibles"
      rows-label-text="Filas"
      cols-label-text="Columnas"
      hide-settings-text="Ocultar opciones"
      show-settings-text="Mostrar opciones"
      select-all-text="Seleccionar todos"
      unselect-all-text="Deseleccionar todos"
    >
      <template slot="value" slot-scope="{ value }">
        {{ value }}
      </template>

      <template slot="mes" slot-scope="{ value }">
        {{ value | mes }}
      </template>
    </pivot>
  </page-edicion>
</template>

<script>
import * as estadisticasApi from "@/services/estadisticas.js";

// PivotTable (https://github.com/Click2Buy/vue-pivot-table)
import Pivot from "@marketconnect/vue-pivot-table";

const meses = [
  "",
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

function makeField(name, label) {
  return {
    key: name,
    getter: (item) => item[name],
    label: label,
    valueFilter: true,
  };
}

function makeMonthField(name, label) {
  return {
    key: name,
    getter: (item) => item[name],
    label: label,
    valueFilter: true,
    headerSlotName: `mes`,
  };
}

export default {
  components: { Pivot },
  filters: {
    mes: (v) => meses[v],
  },
  data: () => {
    return {
      data: [],
      // Pivot params
      fields: [
        makeField("comercial", "Comercial"),
        makeField("pais", "País"),
        makeField("estado", "Estado"),
        makeField("anio", "Año"),
        makeMonthField("mes", "Mes"),
        makeField("anioGanada", "Año Ganada"),
        makeMonthField("mesGanada", "Mes Ganada"),
        makeField("campania", "Campaña"),
        makeField("origen", "Origen"),
        makeField("tipoVenta", "TipoVenta"),
        makeField("sector", "Sector"),
        makeField("motivoCierre", "Motivo"),
      ],
      availableFieldKeys: [
        "comercial",
        "pais",
        "campania",
        "origen",
        "tipoVenta",
        "anioGanada",
        "mesGanada",
        "sector",
        "motivoCierre",
      ],
      colFieldKeys: ["anio"],
      rowFieldKeys: ["mes", "estado"],
      defaultShowSettings: true,

      // Pivot table standalone field params
      rowFields: [],
      colFields: [],
    };
  },
  computed: {
    reducer() {
      return (sum, item) => sum + item.total;
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    cambiarReducer() {
      // Fuerza la actualización del pivot table
      this.cargar();
    },
    async cargar() {
      const data = await estadisticasApi.ofertas();
      this.data = Object.freeze(data);
    },
  },
};
</script>
